import dayjs from "dayjs";
import { Form, Formik } from "formik";
import { FC } from "react";
import { date, object } from "zod";
import { toFormikValidationSchema } from "zod-formik-adapter";

import { Button, Datepicker, Typography } from "@/shared/ui";
import { useOnboardingStore } from "@/stores";

import styles from "./birthday.module.scss";
import { BirthdayTabFormScheme } from "./birthday.types";

const validationScheme = object({
  dateOfBirth: date(),
});

const BirthdayTab: FC = () => {
  const currentStep = useOnboardingStore((state) => state.currentStep);
  const { setCurrentStep, setInfo, addPassedStep } = useOnboardingStore((state) => state.actions);

  const dateOfBirth = useOnboardingStore((state) => state.userInfo.dateOfBirth);

  const onSubmitHandler = (data: BirthdayTabFormScheme) => {
    setInfo(data);
    setCurrentStep(currentStep + 1);
    addPassedStep(currentStep);
  };

  return (
    <main className={styles.birthdayTab}>
      <Typography semi variant="title-2">
        How old are you?
      </Typography>

      <Formik<BirthdayTabFormScheme>
        initialValues={{ dateOfBirth }}
        validationSchema={toFormikValidationSchema(validationScheme)}
        validateOnBlur={false}
        validateOnChange={false}
        onSubmit={onSubmitHandler}
      >
        {({ values, isValid, setFieldValue }) => (
          <Form className={styles.form}>
            <Datepicker
              placeholder={"Date of birth"}
              startMonth={dayjs().subtract(100, "y").toDate()}
              endMonth={dayjs().subtract(18, "y").toDate()}
              disabled={{ after: dayjs().subtract(18, "y").toDate() }}
              defaultMonth={dayjs().subtract(18, "y").toDate()}
              format={"DD MMMM, YYYY"}
              selected={values.dateOfBirth}
              onSelect={(value) => setFieldValue("dateOfBirth", value)}
            />
            <Button fullWidth size="big" type="submit" disabled={!isValid || Object.values(values).some((v) => !v)}>
              Continue
            </Button>
          </Form>
        )}
      </Formik>
    </main>
  );
};

export { BirthdayTab };
